export var SharedActionSource;
(function (SharedActionSource) {
    SharedActionSource["ABT_TAG_TRACK_ACTION"] = "ABT_TAG_TRACK_ACTION";
    SharedActionSource["ABT_WEB_SDK_TRACK_ACTION"] = "ABT_WEB_SDK_TRACK_ACTION";
})(SharedActionSource || (SharedActionSource = {}));
export var ImportHitType;
(function (ImportHitType) {
    ImportHitType["Event"] = "Event";
    ImportHitType["Item"] = "Item";
    ImportHitType["Page"] = "Page";
    ImportHitType["Screen"] = "Screen";
    ImportHitType["Transaction"] = "Transaction";
    ImportHitType["Segment"] = "Segment";
    ImportHitType["Activate"] = "Activate";
    ImportHitType["Troubleshooting"] = "Troubleshooting";
    ImportHitType["UsageHit"] = "UsageHit";
    ImportHitType["ActivateBatch"] = "ActivateBatch";
    ImportHitType["Batch"] = "Batch";
    ImportHitType["HitAbstract"] = "HitAbstract";
    ImportHitType["Diagnostic"] = "Diagnostic";
})(ImportHitType || (ImportHitType = {}));
